export default ($http) => ({
  fetchDashboard() {
    return $http.get('admin')
  },
  fetchPublicSiteSettings() {
    return $http.get('public-site-settings')
  },
  updatePublicSiteSettings(payload) {
    return $http.put('public-site-settings', { body: payload })
  },
  fetchWelcomePage() {
    return $http.get('welcome-page')
  },
  fetchWelcomePageDraft() {
    return $http.get('welcome-page/draft')
  },
  publishWelcomePage() {
    return $http.put('welcome-page')
  },
  saveWelcomePageDraft(payload) {
    return $http.put('welcome-page/draft', { body: payload })
  },
  saveAsyncCoursesSettings(payload) {
    return $http.put('async-courses', { body: payload })
  },
  clearAsyncCoursesSettings() {
    return $http.delete('async-courses')
  },
  fetchMessageBoard() {
    return $http.get('message-board')
  },
  fetchMessageBoardDraft() {
    return $http.get('message-board/draft')
  },
  publishMessageBoard(publish) {
    return $http.put('message-board', { body: { publish } })
  },
  saveMessageBoardDraft(payload) {
    return $http.put('message-board/draft', { body: payload })
  },
  fetchPublicSiteUsage() {
    return $http.get('public-site-usage')
  },
  fetchUnitTemplateCategories ({ filter = '', yearId = '' }) {
    return $http.get('template-categories', { query: { filter, ...(yearId ? { yearId } : {}) } })
  },
  getUnitTemplateCategoryUniqAttributes(payload) {
    return $http.get('template-categories/create')
  },
  updateUnitTemplateCategory(payload) {
    return $http.put(`template-categories/${payload.id}`, { body: payload })
  },
  createUnitTemplateCategory(payload) {
    return $http.post('template-categories', { body: payload })
  },
  deleteUnitTemplateCategory(id) {
    return $http.delete(`template-categories/${id}`)
  },
  getUnitTemplateCategory(id) {
    return $http.get(`template-categories/${id}`)
  },
  getUnitTemplateIdentifiers() {
    return $http.get('template-category-identifiers')
  },
  updateUnitTemplateCategoryOrder(id, payload) {
    return $http.put(`template-categories/change-order/${id}`, { body: payload })
  },
  getDependentDataCounts(id, returnCountTemplates = true) {
    return $http.get(`template-categories/${id}/dependent-data-counts?returnCountTemplates=${returnCountTemplates}`)
  },
  getComplexChecklistSettings() {
    return $http.get('admin/complex-checklist-settings')
  },
  updateComplexChecklistSettings(payload) {
    return $http.put('admin/complex-checklist-settings', { body: { settings: payload } })
  },
  getComplexChecklistData() {
    return $http.get('complex-checklist-items')
  },
  createComplexChecklistMainListItem(payload) {
    return $http.post('admin/complex-checklist/main-list', { body: payload })
  },
  deleteComplexChecklistMainListItem(id) {
    return $http.delete(`admin/complex-checklist/main-list/${id}`)
  },
  updateComplexChecklistMainListItem(payload) {
    return $http.put(`admin/complex-checklist/main-list/${payload.id}`, { body: payload })
  },
  updateComplexChecklistMainListOrder(payload) {
    return $http.put('admin/complex-checklist/main-list/sort', { body: payload })
  },
  createComplexChecklistCheckListItem(payload) {
    return $http.post('admin/complex-checklist/checklist/value', { body: payload })
  },
  updateComplexChecklistCheckListItem(payload) {
    return $http.put(`admin/complex-checklist/checklist/value/${payload.id}`, { body: payload })
  },
  deleteComplexChecklistCheckListItem(id) {
    return $http.delete(`admin/complex-checklist/checklist/value/${id}`)
  },
  updateComplexChecklistCheckListItemsOrder(payload) {
    return $http.put('admin/complex-checklist/checklist/value/sort', { body: payload })
  },
  createComplexChecklistCheckListType(payload) {
    return $http.post('admin/complex-checklist/checklist', { body: payload })
  },
  updateComplexChecklistCheckListType(payload) {
    return $http.put(`admin/complex-checklist/checklist/${payload.id}`, { body: payload })
  },
  deleteComplexChecklistCheckListType(id) {
    return $http.delete(`admin/complex-checklist/checklist/${id}`)
  },
  updateComplexChecklistCheckListTypesOrder(payload) {
    return $http.put('admin/complex-checklist/checklist/sort', { body: payload })
  },
  createAssessmentOpp (payload) {
    return $http.post('admin/assessment-opps', { body: payload })
  },
  updateAssessmentOpp (payload) {
    return $http.put(`admin/assessment-opps/${payload.id}`, { body: payload })
  },
  updateAssessmentOppsSortOrder (payload) {
    return $http.put('admin/assessment-opps/sort', { body: payload })
  },
  deleteAssessmentOpp (payload) {
    return $http.delete(`admin/assessment-opps/${payload.id}`, { body: payload })
  },
  createAssessmentType (payload) {
    return $http.post('admin/assessment-types', { body: payload })
  },
  updateAssessmentType (payload) {
    return $http.put(`admin/assessment-types/${payload.id}`, { body: payload })
  },
  updateAssessmentTypesSortOrder (payload) {
    return $http.put('admin/assessment-types/sort', { body: payload })
  },
  deleteAssessmentType (payload) {
    return $http.delete(`admin/assessment-types/${payload.id}`, { body: payload })
  },
  fetchProficiencyLevels () {
    return $http.get('proficiency-levels')
  },
  createProficiencyLevel (payload) {
    return $http.post('admin/proficiency-levels', { body: payload })
  },
  updateProficiencyLevel (payload) {
    return $http.put(`admin/proficiency-levels/${payload.id}`, { body: payload })
  },
  updateProficiencyLevelsSortOrder (payload) {
    return $http.put('admin/proficiency-levels/sort', { body: payload })
  },
  deleteProficiencyLevel (payload) {
    return $http.delete(`admin/proficiency-levels/${payload.id}`, { body: payload })
  },
  fetchSubjects (query = {}) {
    return $http.get('subjects', { query })
  },
  createSubject (payload) {
    return $http.post('admin/subjects', { body: payload })
  },
  updateSubject (payload) {
    return $http.put(`admin/subjects/${payload.id}`, { body: payload })
  },
  deleteSubject (payload) {
    return $http.delete(`admin/subjects/${payload.id}`, { body: payload })
  },
  fetchSubjectIdentifiers () {
    return $http.get('subjects-identifier')
  },
  fetchMapTypes () {
    return $http.get('map-types')
  },
  createMapType (payload) {
    return $http.post('admin/map-types', { body: payload })
  },
  updateMapType (payload) {
    return $http.put(`admin/map-types/${payload.id}`, { body: payload })
  },
  sortMapTypes (payload) {
    return $http.put('admin/map-types/sort', { body: payload })
  },
  deleteMapType (id) {
    return $http.delete(`admin/map-types/${id}`)
  },
  updateCustomLabels (payload) {
    return $http.put('admin/custom-labels', { body: payload })
  },
  fetchCourseTitlesData(query) {
    return $http.get('admin/course-titles', { query })
  },
  fetchManageCoursesData(query) {
    return $http.get('admin/browse-courses', { query })
  },
  fetchACParentCourses(query) {
    return $http.get('admin/browse-ac-parent-courses', { query })
  },
  fetchManageCoursesRecycleBinData(query) {
    return $http.get('admin/browse-courses/recycle-bin', { query })
  },
  fetchCourseNameOptions(query) {
    return $http.get('admin/manage-courses/course-names', { query })
  },
  fetchCreateCourseOptions(query) {
    return $http.get('admin/manage-courses/create-course-options', { query })
  },
  fetchCreateCourseTitleOptions(query) {
    return $http.get('admin/create-course-title-options', { query })
  },
  getCourse(id) {
    return $http.get(`admin/course/${id}`)
  },
  getRecycledCourse(id, query) {
    return $http.get(`admin/recycled-course/${id}`, { query })
  },
  createCourse(payload) {
    return $http.post('admin/course', { body: payload })
  },
  updateCourse(id, payload) {
    return $http.put(`admin/course/${id}`, { body: payload })
  },
  addUsersToCourses(payload) {
    return $http.put('admin/courses/add-users', { body: payload })
  },
  removeUsersFromCourses(payload) {
    return $http.put('admin/courses/delete-users', { body: payload })
  },
  updateAndRestoreCourse(id, payload) {
    return $http.put(`admin/update-and-restore-course/${id}`, { body: payload })
  },
  getCoursesByCourseTitle(id, query = {}) {
    return $http.get(`admin/courses-by-course-title/${id}`, { query })
  },
  getCoursesByCourseTitleBulk(query = {}) {
    return $http.get('admin/courses-by-course-title-bulk', { query })
  },
  moveCoursesToRecycleBin (payload) {
    return $http.delete('admin/courses', { body: payload })
  },
  restoreCoursesFromRecycleBin (payload) {
    return $http.put('admin/restore-courses', { body: payload })
  },
  getCourseTitle(id) {
    return $http.get(`admin/course-title/${id}`)
  },
  createCourseTitle(payload) {
    return $http.post('admin/course-title', { body: payload })
  },
  updateCourseTitle(id, payload) {
    return $http.put(`admin/course-title/${id}`, { body: payload })
  },
  updateCourseTitleACParent(id, payload) {
    return $http.put(`admin/course-title-ac-parent/${id}`, { body: payload })
  },
  deleteCourseTitle(id, payload = {}) {
    return $http.delete(`admin/course-title/${id}`, { body: payload })
  },
  mergeCourseTitles(payload) {
    return $http.put('admin/course-titles-merge', { body: payload })
  },
  getMergeCourseTitlesOneRosterData(payload) {
    return $http.put('admin/course-titles-merge/one-roster-info', { body: payload })
  },
  assignGradeForCourseTitles(payload) {
    return $http.put('admin/course-titles-assign-grade', { body: payload })
  },
  assignSubjectForCourseTitles(payload) {
    return $http.put('admin/course-titles-assign-subject', { body: payload })
  },
  fetchCourseNamesRecycledCourses(query) {
    return $http.get('admin/browse-recycled-courses-names', { query })
  },
  fetchCourseTitleNames(query) {
    return $http.get('admin/course-title-names', { query })
  },
  importCourseTitlesCsvFile(payload) {
    return $http.post('admin/import-course-titles', { body: payload, headers: { 'Content-Type': 'multipart/form-data' } })
  },
  importCourseTitlesValidate(payload) {
    return $http.post('admin/import-course-titles/validate', { body: payload })
  },
  importCourseTitlesValidateGradesAndSubjects(payload) {
    return $http.post('admin/import-course-titles/validate-grades-subjects', { body: payload })
  },
  importCourseTitlesProcess(payload) {
    return $http.post('admin/import-course-titles/process', { body: payload, timeout: 90000 })
  },
  approveJoinCourseRequest(joinRequestId, payload) {
    return $http.put(`admin/course/approve-join-request/${joinRequestId}`, { body: payload })
  },
  rejectJoinCourseRequest(joinRequestId, payload) {
    return $http.put(`admin/course/reject-join-request/${joinRequestId}`, { body: payload })
  },
  updateResources(payload) {
    return $http.put('/admin/resources', { body: payload, hasNotification: false })
  }
})
